export const BASE_URL = process.env.REACT_APP_SERVER || "http://localhost:4001";
export const BASE_URL_IMG =
  process.env.REACT_APP_IMAGE || "http://localhost:4001/public";
